import "./Icon.css";

import { Plant } from "../../generator/model";
import React from "react";
import background from "../../assets/Frame.png";
import { formatSeasons } from "../../generator/util";
import { plants } from "../../generator/config";

export enum IconPaths {
  fertilizerCompost = "fertilizers/Compost",
  fertilizerManure = "fertilizers/Manure",
  fertilizerGrowthFormula = "fertilizers/Super_Growth_Formula",
  moisture = "Wetness_Meter",
}

interface Props {
  path: IconPaths;
  size?: number;
  frameless?: boolean;
  title?: any;
}

export const Icon = (props: Props) => {
  const { size = 64, frameless = false } = props;
  return (
    <div
      className={"icon-frame"}
      title={props.title}
      style={{
        backgroundImage: background,
        width: size + 2,
        height: size + 2,
        ...(frameless ? { background: "initial" } : {}),
      }}
    >
      <img
        src={process.env.PUBLIC_URL + `/assets/${props.path}.png`}
        alt=""
        width={size}
        height={size}
      />
    </div>
  );
};

export const PlantIcon = ({ name }: { name: string }) => {
  const plant = plants.find((p) => p.name === name) as Plant;
  return (
    <div
      title={[
        `${plant.name}:`,
        `[${plant.growthFormula > 0 ? "+" : ""}${
          plant.growthFormula
        } Growth Formula] [${plant.compost > 0 ? "+" : ""}${
          plant.compost
        } Compost] [${plant.manure > 0 ? "+" : ""}${plant.manure} Manure]`,
        `${plant.water} water consumption`,
        `Seasons: ${formatSeasons(plant.seasons)}`,
      ].join("\n")}
    >
      <Icon path={`fruits/${name}` as IconPaths} />
    </div>
  );
};
